import { useFormContext } from 'react-hook-form';
import { Content } from 'src/contexts/ContentContext';
import { Switch } from 'src/core/interim/Switch';
import { Stack } from 'src/core/ui';
import { ContentId } from 'src/utils/constants/contentId';

import { BulkBulkBarcodeInput } from './BulkBarcodeInput/BulkBulkBarcodeInput';
import { BulkManualBarcodeEntry } from './ManualBarcodeEntry';
import * as styles from './UploadBarcodes.css';
import { BulkBarcodeForm } from './UploadBarcodes.utils';

export const BulkUploadBarcodesBody = ({
  disabled,
}: {
  disabled?: boolean;
}) => {
  const { watch, setValue } = useFormContext<BulkBarcodeForm>();

  const bulkUpload = watch('isBulkUpload');

  return (
    <div className={styles.barcodesContentWrapper}>
      <Content id={ContentId.EnterBarcodesIns} />
      <Stack direction="row" gap="m" alignItems="center" justifyContent="end">
        <Content id={ContentId.BulkEntry} />
        <Switch
          checked={bulkUpload}
          onChange={() => setValue('isBulkUpload', !bulkUpload)}
          disabled={disabled}
        />
      </Stack>
      {!bulkUpload ? (
        <BulkManualBarcodeEntry readOnly={disabled} />
      ) : (
        <BulkBulkBarcodeInput
          readOnly={disabled}
          onPreview={() => setValue('isBulkUpload', !bulkUpload)}
        />
      )}
    </div>
  );
};
